export default {
	URL: 'https://api-fabricaracao.infinitum-ti.com',
	API_URL: 'https://api-fabricaracao.infinitum-ti.com/api',
	OAPI_URL: 'https://api-fabricaracao.infinitum-ti.com/oapi',
	// URL: 'http://localhost:3233',
	// API_URL: 'http://localhost:3233/api',
	// OAPI_URL: 'http://localhost:3233/oapi',
}
